export function applyFeedbackHighlights(content, highlights) {
  if (!content || !Array.isArray(highlights) || highlights.length === 0) {
    return content;
  }

  try {
    if (typeof DOMParser === "undefined" || typeof NodeFilter === "undefined") {
      return content;
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const body = doc.body;

    const highlightExcerpt = (excerpt, note, index) => {
      const target = (excerpt || "").trim();
      if (!target) {
        return;
      }
      const lowerTarget = target.toLowerCase();

      const applyOnce = () => {
        const walker = doc.createTreeWalker(
          body,
          NodeFilter.SHOW_TEXT,
          {
            acceptNode(node) {
              if (!node.nodeValue || !node.nodeValue.trim()) {
                return NodeFilter.FILTER_REJECT;
              }
              const parent = node.parentNode;
              if (
                parent &&
                parent.nodeName === "MARK" &&
                parent.classList &&
                parent.classList.contains("feedback-highlight")
              ) {
                return NodeFilter.FILTER_REJECT;
              }
              return NodeFilter.FILTER_ACCEPT;
            },
          },
          false
        );

        while (walker.nextNode()) {
          const textNode = walker.currentNode;
          const textValue = textNode.nodeValue;
          const matchIndex = textValue.toLowerCase().indexOf(lowerTarget);

          if (matchIndex !== -1) {
            const parent = textNode.parentNode;
            const before = textValue.slice(0, matchIndex);
            const match = textValue.slice(matchIndex, matchIndex + target.length);
            const after = textValue.slice(matchIndex + target.length);

            if (before) {
              parent.insertBefore(doc.createTextNode(before), textNode);
            }

            const mark = doc.createElement("mark");
            mark.className = "feedback-highlight";
            mark.setAttribute("data-feedback-highlight", String(index));
            if (note) {
              mark.setAttribute("title", note);
            }
            mark.textContent = match;
            parent.insertBefore(mark, textNode);

            if (after) {
              parent.insertBefore(doc.createTextNode(after), textNode);
            }

            parent.removeChild(textNode);
            return true;
          }
        }

        return false;
      };

      while (applyOnce()) {
        // Repeat until no more matches in remaining text nodes
      }
    };

    highlights.forEach((item, index) => {
      highlightExcerpt(item?.excerpt, item?.note, index);
    });

    return body.innerHTML || content;
  } catch (error) {
    console.error("Failed to apply feedback highlights", error);
    return content;
  }
}
